import * as React from 'react';

export type Theme = 'light' | 'dark';
export type ThemeSetting = Theme | 'system';
export type ThemeContextValue = {
    setting: ThemeSetting;
    theme: Theme;
    setSetting: (setting: ThemeSetting) => void;
    toggle: () => void;
};

export const ThemeContext = React.createContext<ThemeContextValue | null>(null);
